import { createFileRoute, Outlet } from '@tanstack/react-router'

// Access is enforced by the central route guard in __root.tsx (organization:admin)
export const Route = createFileRoute('/admin/organizations')({
  component: Outlet,
})
